/**
 * Whether an unresolved or unknown flag should be treated as enabled.
 *
 * False by default, so a flag key reads the same locally as it does in
 * production: one that was never created in PostHog stays dark instead of
 * appearing to work. To keep a flagged surface on in local development, give the
 * flag an `environment` release condition in PostHog rather than relying on a
 * fallback here — `entry-client` sends the Vite mode with every flag evaluation.
 *
 * Set `VITE_FORCE_FEATURE_FLAGS=true` in `.env.development.local` to force unresolved flags
 * on anyway, for working offline or without a PostHog key, where nothing
 * resolves at all. Ignored outside development, so it cannot reach a deployed
 * build. A real remote value always wins over it.
 *
 * @returns Whether unresolved flags should be forced on.
 */
export function forcesFeatureFlags(): boolean {
	return import.meta.env.DEV && import.meta.env['VITE_FORCE_FEATURE_FLAGS'] === 'true';
}
